import React, { Component } from 'react';
import ActivityRow from '../components/ActivityRow';

let timeoutListener;

class ActivityWrapper extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentScrollPos: 0
    }

    this.autoScroll = this.autoScroll.bind(this);
  }

  autoScroll() {
    let rows = document.getElementsByClassName('activity-row');
    let activityWrapper = document.getElementById('activity-wrap');
    let currentScrollPos = 0;

    const ourScrolling = () => {

      // declare vars
      let currRow = rows[this.state.currentScrollPos];
      let nextRow = rows[this.state.currentScrollPos + 1];
      let targetScrollTop;
      
      // do logic
      if(nextRow) {
        targetScrollTop = nextRow.getBoundingClientRect().top - 24;
        // console.log(targetScrollTop, currentScrollPos);
        currentScrollPos += targetScrollTop;

        this.setState({
          currentScrollPos: this.state.currentScrollPos + 1
        })
      } else {
        currentScrollPos = 0;
        this.setState({
          currentScrollPos: 0
        });
      };

      //execute logic
      activityWrapper.setAttribute('style', 'transform: translateY(-' + currentScrollPos + 'px)');

    };

    timeoutListener = window.setInterval(ourScrolling, 5000);
  }

  componentDidMount() {
    this.autoScroll();
  }

  componentWillUnmount() {
    window.clearInterval(timeoutListener);
  }

  render() {
    return(
      <div className="wrapper-hack">
        <div id="activity-wrap" className="activity-wrap overflow-visible">
          {this.props.empty && 
            <h2 className="t-red mt5">No Recent Activity!</h2>
          }
          {this.props.activityArray.map((activity, idx) => 
            <ActivityRow key={idx} activity={activity} />
          )}
        </div>
      </div>
    )
  }
}

export default ActivityWrapper;



// WEBPACK FOOTER //
// ./src/components/ActivityWrapper.js